import { useAuth } from "react-oidc-context";
import { Navigate } from "react-router-dom";
import { Logo } from "@/components/layout/Logo";

export default function LoginPage() {
  const auth = useAuth();

  if (auth.isAuthenticated) return <Navigate to="/home" replace />;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="flex justify-center mb-10 h-10 text-brand-navy dark:text-white">
          <Logo />
        </div>

        {/* Card */}
        <div className="bg-surface border border-border rounded-xl shadow-lg px-8 py-10">
          <h1 className="text-xl font-semibold text-primary text-center mb-1">SOC Portal</h1>
          <p className="text-sm text-secondary text-center mb-8">Security Operations Center</p>

          <button
            className="w-full flex items-center justify-center gap-2 bg-brand-cyan hover:bg-brand-cyan/90 text-white font-medium py-2.5 rounded-lg disabled:opacity-50 transition-colors cursor-pointer text-sm"
            onClick={() => auth.signinRedirect()}
            disabled={auth.isLoading}
          >
            {auth.isLoading ? "Signing in…" : "Sign in with SSO"}
          </button>
        </div>

        <p className="text-center text-xs text-muted mt-8">
          &copy; {new Date().getFullYear()} Nagravision SA
        </p>
      </div>
    </div>
  );
}
